module.exports = __webpack_public_path__ + "static/media/party-popper.4ba98e27.png";